import { render, staticRenderFns } from "./GoodsSkuEdit.vue?vue&type=template&id=b119a08a&"
import script from "./GoodsSkuEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsSkuEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports